import * as Dialog from "@radix-ui/react-dialog";
import { Spinner } from "@repo/ui/components/Base/Spinner";

export const Loader = ({ loading }: { loading: boolean }) => {
  return (
    <Dialog.Root open={loading}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-8 rounded-md">
          <Spinner size="lg" />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
